(() => {
  const initContactPage = (root) => {
    if (!root || root.dataset.bvmContactReady === 'true') return;
    root.dataset.bvmContactReady = 'true';

    const form = root.querySelector('[data-bvm-contact-form]');
    const honeypot = root.querySelector('[data-bvm-contact-honeypot]');

    form?.querySelector('form')?.addEventListener("submit", (event) => {
      if (honeypot && honeypot.value.trim() !== '') {
        event.preventDefault();
        honeypot.value = '';
      }
    });


    root.querySelectorAll('[data-bvm-contact-topic-choice]').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(() => form.querySelector('textarea')?.focus({ preventScroll: true }), 500);
      });
    });

    // Reuse the bot's existing flow. The contact form remains a native fallback.
    root.querySelectorAll('[data-bvm-contact-track-order]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const advisor = document.getElementById('bonvent-advisor-host')?.shadowRoot;
        const tracker = advisor?.querySelector('.bottom > .order-link');
        if (!tracker) return;
        tracker.click();
        if (advisor.querySelector('.panel')?.hidden === false) event.preventDefault();
      });
    });

    const hashTarget = window.location.hash;
    if (hashTarget === '#contact-form' && form) {
      window.requestAnimationFrame(() => form.scrollIntoView({ block: 'start' }));
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-bvm-contact-page]').forEach(initContactPage);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
